/* eslint-disable react/no-multi-comp */
import React from 'react'
import { FormattedMessage } from 'react-intl'

export const TIME_SINCE_TIMESTAMP_SECONDS = () => (
    <FormattedMessage
        id="clanmanagement.memberstable.player.offline.seconds"
        defaultMessage="1 минута"
    />
)

export const TIME_SINCE_TIMESTAMP_MINUTES = (value) => (
    <FormattedMessage
        id="clanmanagement.memberstable.player.status.offline.minutes"
        defaultMessage="{value} мин."
        values={{ value }}
    />
)

export const TIME_SINCE_TIMESTAMP_HOURS = (value) => (
    <FormattedMessage
        id="clanmanagement.memberstable.player.status.offline.hours"
        defaultMessage="{value} ч."
        values={{ value }}
    />
)

export const TIME_SINCE_TIMESTAMP_DAYS = (value) => (
    <FormattedMessage
        id="clanmanagement.memberstable.player.status.offline.days"
        defaultMessage="{value} д."
        values={{ value }}
    />
)

export const TIME_SINCE_TIMESTAMP_MONTHS = (value) => (
    <FormattedMessage
        id="clanmanagement.memberstable.player.status.offline.months"
        defaultMessage="{value} мес."
        values={{ value }}
    />
)

export const TIME_SINCE_TIMESTAMP_YEARS = (value) => (
    <FormattedMessage
        id="clanmanagement.memberstable.player.status.offline.years"
        defaultMessage="{value} г."
        values={{ value }}
    />
)



// WEBPACK FOOTER //
// ./containers/ClanManagement/components/FormattedTimeSince/translations.js